import { Input } from "antd";

const { TextArea } = Input;
const UiTextArea = ({
    label,
    placeholder,
    onChange,
    maxLength = 150,
    required = false,
    ...restProps
}) => {
    const handleTextAreaChange = (event) => {
        onChange?.(event);
    };
    const finalMaxLength = Math.min(maxLength, 150);
    return <div>
        <div style={{ padding: "10px" }}>
            {
                label && <label>
                    {label} {required && <span style={{ color: 'red' }}>*</span>}
                </label>
            }
        </div>
        <div style={{ padding: "0px 10px" }}>
            <TextArea
                placeholder={placeholder}
                onChange={handleTextAreaChange}
                maxLength={finalMaxLength}
                {...restProps}
            />
        </div>
    </div>
};
export default UiTextArea